import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import './Layout.css'; 

function Layout() {
  return (
    <div className="home-container">
      <Header />
      <main className="home-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;